<pdp-spinner [attr.data-v]="_appVersion"></pdp-spinner>
<router-outlet ></router-outlet>